import env from '@maui-mf/env'
import { useAuthProvider } from '@maui-mf/common-react'
import { useExperiment } from '@maui-mf/experiments'

export const useIsGTI = () => {
  const { isGTI: user } = useAuthProvider()
  const { enabled: ux } = useExperiment(env.FEATURE_GTI_UX)

  return {
    user,
    ux: user || ux,
  }
}
